import { createBrowserRouter, Navigate } from "react-router-dom";
import { RouterPaths } from "./routerPaths";
import AdminLayout from "../layout/AdminLayout/AdminLayout";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import ProtectedRoute from "./ProtectedRoute";
import RootLayout from "../router/RootLayout";
import authRoutes from "./routes/authRoutes";
import structureRoutes from "./routes/structureRoutes";
import educationalSettingsRoutes from "./routes/educationalSettingsRoutes";
import learningManagementRoutes from "./routes/learningManagementRoutes";
import hrRoutes from "./routes/hrRoutes";
import studentsRoutes from "./routes/studentsRoutes";
import administrationRoutes from "./routes/administrationRoutes";
import languageRoutes from "./routes/languageRoutes";
import settingsRoutes from "./routes/settingsRoutes";
import dashboardRoutes from "./routes/dashboardRoutes";
import otherRoutes from "./routes/otherRoutes";
import nonWorkingRoutes from "./routes/nonWorkingRoutes";

const router = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
            {
                path: RouterPaths.HOME,
                element: <Navigate to={RouterPaths.LOGIN} />,
            },
            {
                element: <AdminLayout />,
                children: authRoutes,
            },
            {
                element: <ProtectedRoute element={<DashboardLayout />} />,
                children: [
                    ...structureRoutes,
                    ...educationalSettingsRoutes,
                    ...learningManagementRoutes,
                    ...hrRoutes,
                    ...studentsRoutes,
                    ...administrationRoutes,
                    ...languageRoutes,
                    ...settingsRoutes,
                    ...nonWorkingRoutes,
                    ...dashboardRoutes,
                ],
            },
            ...otherRoutes,
        ],
    },
]);

export default router;
